import React from "react"



export default function Whitecheckers (){

    // const RenderWhite = () => {

    //     return(

    //         <div className="white">
    //             <div className="tile">

    //                 <div className="face ">
    //                     <div className="facewhite facefront">
    //                     </div>
    //                 </div>

    //                 <div className="row">
    //                     <div className="onewhite subtile">
    //                     </div>
    //                     <div className="twowhite subtile">
    //                     </div>
    //                 </div>

    //                 <div className="row">
    //                     <div className="threewhite subtile">
    //                     </div>
    //                     <div className="fourwhite subtile">
    //                     </div>
    //                 </div>

    //             </div>
    //     </div>

    //     )
    // }

    return(
            
        <div className="white">
            <div className="tile">

                <div className="face ">
                    <div className="facewhite facefront">
                    </div>
                </div>

                <div className="row">
                    <div className="onewhite subtile">
                    </div>
                    <div className="twowhite subtile">
                    </div>
                </div>

                <div className="row">
                    <div className="threewhite subtile">
                    </div>
                    <div className="fourwhite subtile">
                    </div>
                </div>

            </div>
        </div>
            
    )
}